<template>
  <div class="currency" @click="currencyShow = true" @mouseleave="currencyShow = false">
    <div class="usd">
      <div class="usd-left">
        <NuxtImgWrap
          :src="$util.akamai(currency.img_url, 48)"
          width="24"
          height="24"
          alt=""
          loading="lazy"
        />
        <span :key="currency.name" class="notranslate currency-option">{{ currency.name }}</span>
      </div>
      <i class="iconfont icon-tiny1" :class="currencyShow ? 'special-icon' : ''"></i>
    </div>
    <transition name="el-zoom-in-top">
      <ul v-show="currencyShow">
        <li
          v-for="(item, index) in currencyList"
          :key="index"
          class="notranslate"
          :class="item.country"
          @click.stop="clickOk(item)"
        >
          <NuxtImgWrap :src="item.img_url" width="28" height="28" alt="" loading="lazy" /><span
            class="currency-option"
            >{{ item.name }}</span
          >
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
  currencyList: {
    type: Array,
    default: () => [],
  },
  currencyName: {
    type: String,
    default: 'USD',
  },
});
const emit = defineEmits(['clickOk']);

const currencyShow = ref(false);
const currency = computed(() => {
  if (process.server) {
    return {};
  }
  return props.currencyList.find((item) => item.name === props.currencyName) || {};
});

const clickOk = (item) => {
  currencyShow.value = false;
  emit('clickOk', item);
};
</script>

<style lang="scss" scoped>
.currency {
  position: relative;
  padding: 6px 16px;
  width: 240px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    left: -5px;
    right: -5px;
    top: -5px;
    bottom: -5px;
  }
  .usd {
    @include flex(space-between, center);
    .usd-left {
      @include flex($col: center);
      span {
        padding-left: 10px;
      }
    }
  }
  .iconfont {
    display: inline-block;
    margin-left: 3px;
    font-size: 14px;
    transition: all 0.3s;
    cursor: pointer;
  }
  .special-icon {
    transform: rotate(180deg);
  }
  ul {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 38px;
    padding: 10px 0;
    width: 240px;
    height: auto;
    border-radius: 5px;
    background: #ffffff;
    box-shadow: 0 3px 10px 0 rgb(16 17 20 / 10%);
    box-sizing: border-box;
    li {
      @include flex(normal, center);

      padding: 6px 0 6px 20px;
      height: 20%;
      box-sizing: border-box;
      img {
        margin-right: 10px;
      }
      &:hover {
        color: $origin;
        background-color: #f7f5f2;
      }
    }
  }
}
</style>
